type TabId = 'all' | 'today' | 'week' | 'month' | 'wins' | 'losses';

interface FilterTabsProps {
  activeTab: TabId;
  onChange: (tab: TabId) => void;
}

export function FilterTabs({ activeTab, onChange }: FilterTabsProps) {
  const tabs: { id: TabId; label: string }[] = [
    { id: 'all', label: 'All Matches' },
    { id: 'today', label: 'Today' },
    { id: 'week', label: 'This Week' },
    { id: 'month', label: 'This Month' },
    { id: 'wins', label: 'Wins' },
    { id: 'losses', label: 'Losses' },
  ];

  return (
    <div className="flex flex-wrap items-center gap-1.5 p-1 rounded-2xl bg-slate-950/20 border border-white/5 select-none">
      {tabs.map((tab) => {
        const isActive = activeTab === tab.id;
        return (
          <button
            key={tab.id}
            onClick={() => onChange(tab.id)}
            className={`px-4 py-1.5 rounded-xl text-[10px] font-black uppercase tracking-wider transition-all cursor-pointer ${
              isActive
                ? 'bg-purple-600 border border-purple-500/20 text-white shadow-glow'
                : 'bg-transparent border border-transparent text-surface-400 hover:text-white'
            }`}
          >
            {tab.label}
          </button>
        );
      })}
    </div>
  );
}
export default FilterTabs;
